import { cachedFetch } from "theme";

// Use the theme's product dialog without replacing Wiser's React-owned cards
// or its direct-add handler (which also records recommendation attribution).
const buttonSelector = ".template-product .evm-also-bought-products .ws_fbt_widget_design .ws_card_wrapper button.ws_Product_Button:not(.ws_login_btn)";
const directAddClicks = new WeakSet();
let pending = false;
let quickBuyModal;

document.addEventListener("click", async (event) => {
  const button = event.target.closest?.(buttonSelector);
  if (!button) return;

  if (directAddClicks.has(button)) {
    directAddClicks.delete(button);
    return;
  }

  // Capture before React's delegated handler so opening a dialog cannot also
  // add the first variant. This also works when Wiser replaces its cards.
  event.preventDefault();
  event.stopImmediatePropagation();
  if (pending || button.disabled || button.getAttribute("aria-busy") === "true") return;

  const card = button.closest(".ws_card_wrapper");
  const link = card.querySelector("a.ws-product-title-link");
  if (!link) return;
  const productUrl = new URL(link.href, window.location.href);
  if (productUrl.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(productUrl.pathname)) return;

  pending = true;
  button.setAttribute("aria-busy", "true");
  button.classList.add("ws-loading");
  let directAdd = false;

  try {
    // Use Shopify's complete product metadata, not the app's filtered options.
    // The native modal reuses this cached response when it opens.
    const response = await cachedFetch(productUrl.pathname);
    if (!response.ok) throw new Error("Could not load the recommended product");
    const productDocument = new DOMParser().parseFromString(await response.text(), "text/html");
    const product = productDocument.getElementById("quick-buy-content")?.dataset;
    if (!product?.productHandle || !product.hasOnlyDefaultVariant || product.sellingPlanCount === undefined) {
      throw new Error("Recommended product data is incomplete");
    }
    if (!button.isConnected) return;

    // Match the existing product cards: app-personalized items must complete
    // their required customization on the product page.
    if (product.productTemplate === "product-link-variations") {
      window.location.assign(productUrl.href);
      return;
    }

    directAdd = product.hasOnlyDefaultVariant === "true" && product.sellingPlanCount === "0";

    if (!directAdd) {
      if (!quickBuyModal) {
        quickBuyModal = document.createElement("quick-buy-modal");
        quickBuyModal.id = "wiser-pdp-quick-buy";
        quickBuyModal.className = "quick-buy-modal modal";
        document.body.append(quickBuyModal);
      }
      quickBuyModal.setAttribute("handle", product.productHandle);
      quickBuyModal.setAttribute("aria-label", product.productTitle);
      button.setAttribute("aria-controls", quickBuyModal.id);
      button.setAttribute("aria-haspopup", "dialog");
      button.focus({ preventScroll: true });
      await quickBuyModal.show();
    }
  } catch (error) {
    // Never guess a variant or submit an unintended cart request on failure.
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    window.location.assign(productUrl.href);
  } finally {
    pending = false;
    button.removeAttribute("aria-busy");
    button.classList.remove("ws-loading");
  }

  if (directAdd && button.isConnected) {
    directAddClicks.add(button);
    button.click();
    directAddClicks.delete(button);
  }
}, { capture: true });

// If this module fails to load, keep Wiser's original variant controls usable.
document.body.classList.add("wiser-pdp-quick-buy-ready");
